import { apiGet } from "./client";
import type { RoundCurrent } from "../types/api";

// GET /api/v1/round/current — public, no credentials. See docs/API_CONTRACT.md.
export function getCurrentRound(signal?: AbortSignal) {
  return apiGet<RoundCurrent>("/api/v1/round/current", signal);
}
